import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import styles from './Billing.module.css';

/**
 * Pouso do Stripe quando o usuário desiste no checkout: `/billing/cancel`.
 * Nenhuma cobrança aconteceu — a tela só diz isso e devolve ao faturamento.
 */
export function BillingCancel() {
  const { t } = useTranslation(['funil', 'common']);

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h1 className={styles.title}>{t('funil:billing_cancel.titulo')}</h1>
        </div>

        <div className={styles.card}>
          <p>{t('funil:billing_cancel.mensagem')}</p>
          <Link to="/billing">{t('funil:billing_cancel.voltar_billing')}</Link>
        </div>
      </div>
    </div>
  );
}
